import { render, staticRenderFns } from "./ShokurekishoSkillsheetPreview.vue?vue&type=template&id=0a06afed"
import script from "./ShokurekishoSkillsheetPreview.vue?vue&type=script&lang=js"
export * from "./ShokurekishoSkillsheetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports